import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Chip,
  Divider
} from '@mui/material';
import {
  Delete,
  InsertDriveFile,
  FileCopy
} from '@mui/icons-material';
import { formatFileSize } from './utils/fileUtils';
import './SelectedFilesList.css';

const SelectedFilesList = ({ files, onRemoveFile }) => {
  if (files.length === 0) return null;

  return (
    <Paper className="selected-files-container">
      <Box className="selected-files-header">
        <Typography variant="h6" className="selected-files-title">
          Selected Documents
        </Typography>
        <Chip 
          label={`${files.length} file${files.length > 1 ? 's' : ''} ready to upload`}
          className="selected-files-chip"
        />
      </Box>
      
      <List className="selected-files-list">
        {files.map((file, index) => (
          <React.Fragment key={file.id}>
            <ListItem className="selected-file-item">
              <ListItemIcon className="file-icon">
                <InsertDriveFile />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography className="file-name">
                    {file.name}
                  </Typography>
                }
                secondary={
                  <Typography className="file-details">
                    <FileCopy className="file-copy-icon" />
                    {formatFileSize(file.size)} • Ready to upload
                  </Typography>
                }
              />
              <IconButton 
                onClick={() => onRemoveFile(file.id)}
                className="remove-file-btn"
              >
                <Delete />
              </IconButton>
            </ListItem>
            {index < files.length - 1 && (
              <Divider className="file-divider" />
            )}
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};

export default SelectedFilesList;
